import { CommunicationsSettingBase } from './notifications-settings-base.model';

export class SmsCommunicationSetting extends CommunicationsSettingBase {
  title: string;
  message: string;
  messageWithLineBreaks: string;
}
